<template>
  <div class="page-box" style="position: relative;">
    <el-form ref="activityFilter" :model="activity" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350"
        @search="refreshActivity(true)"
        @reset="onResetActivity"
      >
        <el-form-item label="创建时间" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="activity.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="活动内容" prop="formFilter.activityContent">
          <el-input class="filter-item" v-model="activity.formFilter.activityContent"
            :clearable="true" placeholder="活动内容"
          />
        </el-form-item>
<!--        <el-form-item label="创建人" prop="formFilter.createUserId">-->
<!--          <el-input-number class="filter-item" v-model="activity.formFilter.createUserId"-->
<!--            :clearable="true"-->
<!--            placeholder="创建人"-->
<!--          />-->
<!--        </el-form-item>-->
        <el-form-item label="参与人数" prop="formFilter.participants">
          <el-select class="filter-item" v-model="activity.formFilter.participants" :clearable="true" filterable
            placeholder="参与人数" :loading="activity.participants.impl.loading"
            @visible-change="activity.participants.impl.onVisibleChange"
            @change="onParticipantsValueChange">
            <el-option v-for="item in activity.participants.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="组织部门" prop="formFilter.orgCode">
          <el-select class="filter-item" v-model="activity.formFilter.orgCode" :clearable="true" filterable
            placeholder="组织部门" :loading="activity.orgCode.impl.loading"
            @visible-change="activity.orgCode.impl.onVisibleChange"
            @change="onOrgCodeValueChange">
            <el-option v-for="item in activity.orgCode.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetActivity">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshActivity(true)">查询
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('activityList:activity:activityForm')"
                   @click="onActivityFormClick()">
          新增
        </el-button>

      </filter-box>

    </el-form>
      <el-table ref="activity"  header-cell-class-name="table-header-gray"
        :data="activity.Activity.impl.dataList" :size="defaultFormItemSize"
        @sort-change="activity.Activity.impl.onSortChange"
                @selection-change="onActivitySelectionChange"
        @refresh="refreshActivity(true)"
      >
        <!-- 表格操作 -->

        <!-- 表格列 -->
        <el-table-column label="序号" type="index" width="50px" :index="activity.Activity.impl.getTableIndex" />
        <el-table-column label="创建人" prop="createUserIdDictMap.name" />
        <el-table-column label="辖区" prop="orgCodeDictMap.name" />
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">
            <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="活动内容" prop="activityContent" />

        <el-table-column label="参与人数" prop="participantsDictMap.name">
        </el-table-column>
        <el-table-column label="现场图片" min-width="100px">
          <template slot-scope="scope">
            <el-image v-for="item in parseUploadData(scope.row.siteImages, {id: scope.row.id, fieldName: 'siteImages', asImage: true})"
                      :preview-src-list="getPictureList(scope.row.siteImages, {id: scope.row.id, fieldName: 'siteImages', asImage: true})"
                      class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
              <div slot="error" class="table-cell-image">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click.stop="onActivityFormUpdateClick(scope.row)" type="text" :size="defaultFormItemSize"
              :disabled="!checkPermCodeExist('activityList:activity:activityFormUpdate')">
              编辑
            </el-button>
            <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
              :disabled="!checkPermCodeExist('activityList:activity:delete')">
              删除
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty unified-font">
            <img src="@/assets/img/empty.png">
            <span>暂无数据</span>
          </div>
        </template>
        <!-- 分页 -->

      </el-table>
    <el-row slot="pagination" type="flex" justify="end" style="margin-top: 10px;">
      <el-pagination
        :total="activity.Activity.impl.totalCount"
        :current-page="activity.Activity.impl.currentPage"
        :page-size="activity.Activity.impl.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, prev, pager, next, sizes"
        @current-change="activity.Activity.impl.onCurrentPageChange"
        @size-change="activity.Activity.impl.onPageSizeChange">
      </el-pagination>
    </el-row>

  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { ActivityController, DictionaryController } from '@/api';

export default {
  name: 'activityList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      activity: {
        formFilter: {
          createTime: [],
          activityContent: undefined,
          createUserId: undefined,
          participants: undefined,
          orgCode: undefined
        },
        formFilterCopy: {
          createTime: [],
          activityContent: undefined,
          createUserId: undefined,
          participants: undefined,
          orgCode: undefined
        },
        Activity: {
          impl: new TableWidget(this.loadActivityWidgetData, this.loadActivityVerify, true, false)
        },
        participants: {
          impl: new DropdownWidget(this.loadParticipantsDropdownList)
        },
        orgCode: {
          impl: new DropdownWidget(this.loadOrgCodeDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetActivity () {
      this.$refs.activityFilter.resetFields();
      this.refreshActivity(true);
    },
    /**
     * 活动数据获取函数，返回Promise
     */
    loadActivityWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        activityDtoFilter: {
          createTimeStart: Array.isArray(this.activity.formFilterCopy.createTime) ? this.activity.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.activity.formFilterCopy.createTime) ? this.activity.formFilterCopy.createTime[1] : undefined,
          activityContent: this.activity.formFilterCopy.activityContent,
          orgCode: this.activity.formFilterCopy.orgCode,
          participants: this.activity.formFilterCopy.participants
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        ActivityController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 活动数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadActivityVerify () {
      this.activity.formFilterCopy.createTime = this.activity.formFilter.createTime;
      this.activity.formFilterCopy.activityContent = this.activity.formFilter.activityContent;
      this.activity.formFilterCopy.orgCode = this.activity.formFilter.orgCode;
      this.activity.formFilterCopy.participants = this.activity.formFilter.participants;
      return true;
    },
    /**
     * 参与人数下拉数据获取函数
     */
    loadParticipantsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictParticipantsNumber(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 参与人数选中值改变
     */
    onParticipantsValueChange (value) {
    },
    /**
     * 组织部门下拉数据获取函数
     */
    loadOrgCodeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {parentId: '1526381006418874368'};
        DictionaryController.dictSysDeptByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 组织部门选中值改变
     */
    onOrgCodeValueChange (value) {
    },
    /**
     * 更新辖区活动
     */
    refreshActivity (reloadData = false) {
      if (reloadData) {
        this.activity.Activity.impl.refreshTable(true, 1);
      } else {
        this.activity.Activity.impl.refreshTable();
      }
      if (!this.activity.isInit) {
        // 初始化下拉数据
      }
      this.activity.isInit = true;
    },
    onActivitySelectionChange (values) {
      this.activity.Activity.deleteRows = (values || []).map(item => {
        return item.id;
      });
    },
    /**
     * 新增
     */
    onActivityFormClick () {
      let params = {};

      params.closeVisible = 1;
      this.$router.push({name: 'activityForm', query: params});
    },
    /**
     * 编辑
     */
    onActivityFormUpdateClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'activityForm', query: params});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      ActivityController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.activity.Activity.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshActivity();
    },
    initFormData () {
    },
    formInit () {
      this.refreshActivity();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
